const {
  VUE_APP_TEST_WEIGHTING
} = process.env

export const state = {
  testGroup: undefined
}

export const mutations = {
  SET_TEST_GROUP (state, payload) {
    state.testGroup = payload
  }
}

export const actions = {
  actionSetTestGroup ({ commit }) {
    if (VUE_APP_TEST_WEIGHTING === undefined) return
    const randomNumber = Math.floor(Math.random() * 100)
    commit('SET_TEST_GROUP', randomNumber < VUE_APP_TEST_WEIGHTING)
  }
}
